import dayjs from 'dayjs'

export const isApac:boolean = process.env.REACT_APP_REGION === 'apac'

export const isNonApac = process.env.REACT_APP_REGION !== 'apac'

export const apacDateFormat=(date: string | number | Date | dayjs.Dayjs | null | undefined)=> dayjs(date).format('DD/MM/YYYY')

export const centerLngLat = isApac ? [-130, -25] : [-98.5795, 39.8283];
